export default {
  id: "command-combat",
  pride: 2048,
  slug: "command-combat",
  category: "game",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "指令对决",
    en: "Command Combat"
  },
  image: "https://img.itch.zone/aW1nLzIzNTAwNzY3LmpwZWc=/315x250%23c/RXexwa.jpeg",
  descriptionKey: {
    zh: "策略性回合制文字格斗游戏。预判 AI 行动，在 5 秒内选择克制指令取得胜利。两小时速成试作。",
    en: "A strategic turn-based text fighter. Predict the AI's move and pick the right counter command within 5 seconds. A two-hour prototype."
  },
  genres: ["格斗", "回合制", "策略"],
  themes: ["指令", "克制"],
  platform: ["Web"],
  developerNotesKey: {
    zh: "两小时做的试作品。有距离系统、指令克制、搓招连击等机制，支持连续挑战3个强度不同的敌人。浏览器即玩，无需安装。",
    en: "A two-hour prototype. Features a distance system, command countering, combo inputs, and three enemies of escalating difficulty. Playable in-browser, no install needed."
  },
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "itch", url: "https://tobenot.itch.io/commmand-combat", textKey: { zh: "itch.io 游玩", en: "Play on itch.io" } }
  ]
};
